'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import {
  AppsUsageSection,
  AppsUsageSectionProps,
} from '@components/appsUsageSection';
import { memo } from 'react';

import { useGetClientHost } from '@/shared/hooks';
import { Domain } from '@/shared/types';
import { getDomainKey } from '@/shared/utils/getDomainInfo';

export const AppsUssageSectionWithImageForDomain = memo(
  ({
    imagesByDomain,
    ...props
  }: AppsUsageSectionProps & {
    imagesByDomain: Record<Domain, AppImageData>;
  }) => {
    const domain = getDomainKey(useGetClientHost());
    const imageData = imagesByDomain[domain];

    if (!imageData) {
      return null;
    }

    return (
      <AppsUsageSection
        {...props}
        imageData={imageData}
        imageNode={
          <div className="flex items-end justify-end pr-9 max-sm:justify-center max-sm:p-0">
            <AppImageClient
              {...imageData}
              alt={props.title}
              className="h-[344px] w-[301px] max-w-none object-contain max-sm:h-auto max-sm:w-full"
            />
          </div>
        }
      />
    );
  },
);

AppsUssageSectionWithImageForDomain.displayName =
  'AppsUssageSectionWithImageForDomain';
